import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=a83b1de8&scoped=true&"
import script from "./Promotions.vue?vue&type=script&lang=js&"
export * from "./Promotions.vue?vue&type=script&lang=js&"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=a83b1de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83b1de8",
  null
  
)

export default component.exports